import React, { useEffect, useState } from "react";
import Icon from "../../../icons";
import Avatar from "react-avatar";

const SEARCH_DEBOUNCE_MS = 400;

const UserRow = ({ user, selected, onSelect }) => {
  const fullName = `${user.firstName || ""} ${user.lastName || ""}`.trim();
  return (
    <li
      tabIndex={0}
      onClick={() => onSelect(user)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(user);
        }
      }}
    >
      <div className="org_access__userPic rowFlex">
        <div className="mr">
          <Avatar round={true} size="32" maxInitials={2} name={fullName} />
        </div>
        <div>
          <div>
            <strong>{fullName}</strong>
            {user.organization ? ` — ${user.organization}` : ""}
          </div>
          <div>{user.email}</div>
        </div>
        {selected && <span className="badges checked selectChecked green"></span>}
      </div>
    </li>
  );
};

const AddUserModal = ({
  onCancelPress,
  onProvideAccess,
  searchedUsers,
  searchLoading,
  handleSearch,
}) => {
  const [searchEmail, setSearchEmail] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  // Nothing is fetched on open; search only once the user enters an email.
  useEffect(() => {
    const term = searchEmail.trim();
    if (!term) return undefined;
    const timer = setTimeout(() => handleSearch(term), SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [searchEmail]);

  const onSearchChange = (value) => {
    setSearchEmail(value);
    setSelectedUser(null);
    if (!value.trim()) handleSearch("");
  };

  const users = Array.isArray(searchedUsers) ? searchedUsers : [];

  const getInfoText = () => {
    if (!searchEmail.trim()) return "Enter an email to search users.";
    if (searchLoading) return "Loading...";
    if (users.length === 0) return "No users found.";
    return null;
  };

  const renderResults = () => {
    if (selectedUser) {
      return (
        <div className="search-listing search-listing__selected">
          <ul>
            <UserRow user={selectedUser} selected onSelect={() => setSelectedUser(null)} />
          </ul>
        </div>
      );
    }
    const infoText = getInfoText();
    if (infoText) {
      return (
        <div className="search-listing__info org_access__info">
          <p>{infoText}</p>
        </div>
      );
    }
    return (
      <div className="search-listing">
        <ul>
          {users.map((user) => (
            <UserRow key={user.id} user={user} onSelect={setSelectedUser} />
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="modal">
      <div className="modalContent small">
        <div className="modalHeader rowSpaceBetween alignMiddle">
          <h1>Add User</h1>
          <Icon name="close" className="icon close" onClick={onCancelPress} />
        </div>
        <div className="modalBody">
          <div className="org_access__add--user">
            <div className="formGroup mrNone">
              <div className="search rowFlex">
                <input
                  type="search"
                  placeholder="Search by email"
                  value={searchEmail}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch(searchEmail.trim());
                    }
                  }}
                  onChange={(e) => onSearchChange(e.target.value)}
                />
                <div className="search__icon">
                  <ul className="rowFlex">
                    {searchEmail && (
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            onSearchChange("");
                          }}
                        >
                          <Icon name="close" className="icon iconSmall" />
                        </a>
                      </li>
                    )}
                    <li>
                      <a href="javascript:void(0)">
                        <Icon
                          name="search"
                          className="icon searchIcon"
                          onClick={() => handleSearch(searchEmail.trim())}
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {renderResults()}
        </div>
        <div className="modalFooter">
          <button
            className="btn-cc__primary"
            disabled={!selectedUser}
            onClick={() => onProvideAccess(selectedUser.id)}
          >
            Provide Access
          </button>
          <button className="btn-cc__link" onClick={onCancelPress}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUserModal;
